import { useCourseDetailStore } from "@/stores/courseDetailStore";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export const CourseBreadcrumb = () => {
  const { parentChapter, parentModule } = useCourseDetailStore();

  if (!parentModule && !parentChapter) {
    return null;
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {parentModule && (
          <>
            <BreadcrumbItem>
              <BreadcrumbPage className="text-sm text-foreground">
                {parentModule.title}
              </BreadcrumbPage>
            </BreadcrumbItem>
            {parentChapter && <BreadcrumbSeparator />}
          </>
        )}
        {parentChapter && (
          <BreadcrumbItem>
            <BreadcrumbPage className="text-sm text-foreground">
              {parentChapter.title}
            </BreadcrumbPage>
          </BreadcrumbItem>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
